const operatorMessages = {
  'operator.dashboard.title': '連絡先',
  'operator.dashboard.message.notAllowed': '権限により連絡先は非表示です',
  'operator.dashboard.tab.operators': '作業者',
  'operator.dashboard.tab.favorites': 'お気に入り',
  'operator.dashboard.favorites.add': 'お気に入り追加',
  'operator.dashboard.remote.clear': '全てクリア',
  'operator.dashboard.remote.call': '発信',
  'operator.dashboard.remote.blackboard': '黒板',
  'operator.dashboard.remote.edit': '編集',
  'operator.dashboard.operators.title': '名称',
  'operator.favorites.dialog.title.add': 'お気に入り追加',
  'operator.favorites.dialog.title.edit': 'お気に入り編集',
  'operator.favorites.dialog.name': '名称',
  'operator.favorites.dialog.menber': 'メンバー選択',
  'operator.OperatorLists.title.accountName': 'アカウント名',
  'operator.OperatorLists.title.userName': 'ユーザー氏名',
  'operator.OperatorLists.title.mailAddress': 'メールアドレス',
  'operator.OperatorLists.title.license': 'ライセンス',
  'operator.OperatorLists.title.remoteSupportLicense': '遠隔支援ライセンス',
  'operator.OperatorLists.title.companyName': '企業名',
  'operator.OperatorLists.title.deviceName': '機器名',
  'operator.OperatorLists.title.status': 'ステータス',
  'operator.OperatorLists.title.support': 'サポート',
  'operator.OperatorLists.title.role': '権限',
  'operator.OperatorLists.title.loginId': 'ログインID',
  'operator.OperatorLists.title.accountStatus': '状態',
  'operator.OperatorLists.title.remoteSupportStatus': '遠隔支援',
  'operator.title': '作業者',
  'operator.OperatorLists.accountStatus.select.default':
    '状態で絞り込み(デフォルト:全状態)',
  'operator.OperatorLists.accountStatus.select.1': '有効',
  'operator.OperatorLists.accountStatus.select.2': '無効',
  'operator.OperatorLists.accountStatus.select.0': '削除',
  'operator.OperatorLists.remoteSupportStatus.select.default':
    '遠隔支援状態で絞り込み(デフォルト:全状態)',
  'operator.OperatorLists.remoteSupportStatus.select.1': '有効',
  'operator.OperatorLists.remoteSupportStatus.select.0': '無効',
  'operator.OperatorLists.status.0': '作業中',
  'operator.OperatorLists.status.1': '緊急',
  'operator.OperatorLists.status.2': '確認',
  'operator.role.status.0': 'ゲスト',
  'operator.role.status.1': '一般利用者',
  'operator.role.status.5': '管理者',
  'operator.role.status.10': '企業管理者',
  'operator.role.status.20': 'サービスベンダー',
  'operator.role.status.90': 'root',
  'operator.accountStatus.1': '有効',
  'operator.accountStatus.2': '無効',
  'operator.accountStatus.0': '削除',
  'operator.accountStatus.sp': '--',
  'operator.remoteSupportStatus.1': '有効',
  'operator.remoteSupportStatus.0': '無効',
  'operator.remoteSupportStatus.2': '--',
  'operator.updateStaff.message.error.accountStatus.1103':
    'ユーザライセンス数を超過しているため「有効」にできません',
  'operator.updateStaff.message.error.remoteSupportStatus.1105':
    '遠隔支援ライセンス数を超過しているため「有効」にできません',
  'operator.updateStaff.message.error.remoteSupportStatus.1106':
    '遠隔支援ライセンスが無効のため「有効」にできません',
  'operator.updateStaff.button.title': '更新',
  'operator.select.default': '作業者で絞り込み',
  'operator.select.title': 'ユーザー：',
};

export default operatorMessages;
